import React from 'react';
import { format } from 'date-fns';

import type { Event } from '@/types';

import type { CalendarDayData } from './types';

const EventDetails = ({ event }: { event: Event }) => {
  const eventHref = `/e/${event.id}`;
  return (
    <div className="calendar-event-details">
      {event.url_image && (
        <a className="event-img-link" href={eventHref}>
          <img
            className="img-fluid mb-2"
            src={event.url_image}
            alt={`${event.name} event flyer`}
          />
        </a>
      )}
      <p className="text-white mb-2">
        <a className="text-decoration-none" href={eventHref}>
          {event.name}
        </a>
      </p>
      <span className="badge bg-secondary">
        {format(new Date(event.start), 'h:mm aa')}
      </span>
    </div>
  );
};

const CalendarDay = ({ calendarDay }: { calendarDay: CalendarDayData }) => {
  const { date, events } = calendarDay;

  return (
    <div className="calendar-day">
      <div className="text-center mb-2">{format(new Date(date), 'L/d')}</div>
      {events &&
        events.map((event) => <EventDetails event={event} key={event.id} />)}
    </div>
  );
};

export default CalendarDay;
